import { useEffect, useState } from 'react';
import type { HandraiserConfig } from '../../types/hrConfigTypes';

const isHandraiserConfig = (data: unknown): data is HandraiserConfig => {
  return (
    typeof data === 'object' &&
    data !== null &&
    'HANDRAISER_CONFIG_US' in data &&
    'HANDRAISER_CONFIG_CA' in data
  );
};

export const useFetchJsonConfig = (hrConfigUrl: string) => {
  const [hrConfig, setHrConfig] = useState<HandraiserConfig | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDealers = async () => {
      try {
        setLoading(true);
        const response = await fetch(hrConfigUrl);
        if (!response.ok) {
          throw new Error(`Failed to fetch: ${response.status}`);
        }
        const data: unknown = await response.json();
        if (isHandraiserConfig(data)) {
          setHrConfig(data);
        } else {
          throw new Error('Invalid JSON format');
        }
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      } finally {
        setLoading(false);
      }
    };
    fetchDealers();
  }, [hrConfigUrl]);

  return { hrConfig, loading, error };
};
